const Address = require('./Address');
const {DevelopmentStage} = require('./Interfaces');
const Source = require('./Source');

class Child {
  constructor() {
    this.init();
  }

  init() {
    this.child_id = undefined;
    this.parent_id = undefined;
    this.first_name = undefined;
    this.last_name = '';
    this.development_stage = undefined;
    this.birth_date = undefined;
    this.born = undefined;
    this.gender = undefined;
    this.source = undefined;
    this.legup_list_id = undefined;
    this.address = new Address();
  }

  copy() {
    const cp = new Child();

    cp.child_id = this.child_id;
    cp.parent_id = this.parent_id;
    cp.first_name = this.first_name;
    cp.last_name = this.last_name;
    cp.birth_date = this.birth_date;
    cp.gender = this.gender;
    cp.born = this.born;
    cp.source = this.source;
    cp.legup_list_id = this.legup_list_id;
    cp.address = this.address;

    if (this.development_stage) {
      cp.development_stage = [];
      this.development_stage.forEach((s) => {
        cp.development_stage.push(s);
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      // Should we do more validation on birth date and is born?
      this.child_id = obj.child_id ? obj.child_id.toString() : undefined;
      this.parent_id = obj.parent_id ? obj.parent_id.toString() : undefined;
      this.first_name = obj.first_name ? obj.first_name : undefined;
      this.last_name = obj.last_name ? obj.last_name : '';
      this.birth_date = obj.birth_date ? new Date(obj.birth_date) : undefined;
      this.gender = ((obj.gender === 'male') || (obj.gender === 'female') || (obj.gender === 'other')) ? obj.gender : undefined;
      this.born = ((obj.born === 'born') || (obj.born === 'trying') || (obj.born === 'expecting')) ? obj.born : undefined;
      this.legup_list_id = obj.legup_list_id ? obj.legup_list_id : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});

      if (obj.source) {
        const values = Object.keys(Source).map(s => Source[s]);
        if (values.indexOf(obj.source) > -1) {
          this.source = obj.source;
        }
      }

      if (obj.development_stage) {
        this.development_stage = [];
        const values = Object.keys(DevelopmentStage).map(s => DevelopmentStage[s]);
        obj.development_stage.forEach((s) => {
          if (values.indexOf(s) > -1) {
            this.development_stage.push(s);
          }
        });
      }
    }
  }

  toString() {
    let result = this.first_name ? this.first_name : 'Baby';
    const address = this.address.toString();

    if (this.last_name && this.last_name.length) {
      result = (result.length) ? `${result} ${this.last_name}` : this.last_name;
    }
    if (this.birth_date) {
      if (this.born) {
        result = `${result}: born ${this.birth_date}`;
      } else {
        result = `${result}: expected ${this.birth_date}`;
      }
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.child_id;
  }

  setId(child_id) {
    this.child_id = child_id ? child_id.toString() : undefined;
  }

  getParentId() {
    return this.parent_id;
  }

  setParentId(parent_id) {
    this.parent_id = parent_id ? parent_id.toString() : undefined;
  }

  getName() {
    let result = this.first_name ? this.first_name : 'Baby';

    if (this.last_name && this.last_name.length) {
      result = (result.length) ? `${result} ${this.last_name}` : this.last_name;
    }

    return result;
  }

  getFirstName() {
    return this.first_name;
  }

  setFirstName(first_name) {
    this.first_name = first_name;
  }

  getLastName() {
    return this.last_name;
  }

  setLastName(last_name) {
    this.last_name = last_name;
  }

  getBirthDate() {
    return this.birth_date;
  }

  setBirthDate(birth_date) {
    this.birth_date = (birth_date) ? new Date(birth_date) : undefined;
  }

  getGender() {
    return this.gender;
  }

  setGender(gender) {
    if ((gender === undefined) || (gender === 'male') || (gender === 'female') || (gender === 'other')) {
      this.gender = gender;
    }
  }

  getBorn() {
    return this.born;
  }

  setBorn(born) {
    if ((born === 'born') || (born === 'expecting') || (born === 'trying')) {
      this.born = born;
    }
  }

  getSource() {
    return this.source;
  }

  setSource(source) {
    if (source) {
      const values = Object.keys(Source).map(s => Source[s]);
      if (values.indexOf(source) > -1) {
        this.source = source;
      }
    } else {
      this.source = undefined;
    }
  }

  getDevelopmentStage() {
    return this.development_stage;
  }

  setDevelopmentStage(development_stage) {
    if (development_stage) {
      this.development_stage = [];
      const values = Object.keys(DevelopmentStage).map(s => DevelopmentStage[s]);
      development_stage.forEach((s) => {
        if (Object.keys(values).indexOf(s) > -1) {
          this.development_stage.push(s);
        }
      });
    } else {
      this.development_stage = undefined;
    }
  }

  getLegupListId() {
    return this.legup_list_id;
  }

  setLegupListId(list_id) {
    this.legup_list_id = list_id;
  }

  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }
}

module.exports = Child;
